import { isBoolean, isString } from 'lodash';

type TObjectValidationScheme = {
  type: string;
  required?: boolean;
  properties: Record<
    string,
    {
      type: string;
      required?: boolean;
      itemScheme?: TObjectValidationScheme;
      properties?: Record<string, any>;
      validator?: (value: any) => boolean;
    }
  >;
  itemScheme?: TObjectValidationScheme;
};

export const baseInputValidationScheme: TObjectValidationScheme = {
  type: 'object',
  required: true,
  properties: {
    name: {
      type: 'string',
      required: true,
    },
    required: {
      type: 'boolean',
    },
    formOnly: {
      type: 'boolean',
    },
    validation: {
      type: 'array',
      itemScheme: {
        type: 'object',
        properties: {
          isWrongMessage: {
            type: 'string',
            required: true,
          },
          isWrong: {
            type: 'custom',
            validator: value => isString(value) || isBoolean(value),
          },
        },
      },
    },
  },
};
